export default [
  {
    name: 'Décors de scène',
    description:
      'Le décor de scène est bien plus qu’un simple arrière-plan : il est une extension de l’histoire, un élément essentiel qui transporte le spectateur dans un univers unique. Chaque décor est conçu pour servir la mise en scène, renforcer l’émotion et donner vie à l’imaginaire des œuvres.',
    thumbnail: 'theatre.png',
    url: 'decors-scene',
    credit:
      'Accréditation des photos: Catherine Charron-Drolet, Emmanuel Burriel, Jessica Latouche, Vincent Champoux, Silverchip Photos',
    images: [
      'opera2.png',
      'opera3.png',
      't+o2.png',
      't+o3.png',
      'opera4.png',
      'theatre1.png',
      'opera1.png',
      'opera5.png',
      'opera6.png',
      'opera7.png',
      'opera8.png',
      'theatre2.png',
      'opera9.png',
      'theatre3.jpg',
      'theatre4.jpg',
      'theatre5.jpg',
      'theatre6.jpg',
      't+o1.png',
      't+o4.png',
      't+o5.png',
      't+o6.png',
      't+o7.png',
      't+o10.jpeg',
      't+o8.png',
      't+o9.png',
      'to10.png',
      'to21.jpg',
      'to11.jpeg',
      'to12.jpg',
      'to13.jpg',
      'to14.jpg',
      'to15.jpg',
      'to16.jpg',
      'scene-1.jpg',
      'to17.jpg',
      'to22.jpg',
      'to18.jpg',
      'to19.jpg',
      'to23.png',
      'to20.jpg'
    ]
  },
  {
    name: 'Kiosque produits',
    description:
      'Qu’ils soient installés dans un centre commercial, un marché ou un événement, les kiosques sont des espaces stratégiques qui attirent l’attention et mettent en valeur les produits de nos clients.',
    thumbnail: 'produit.png',
    url: 'kiosque-produits',
    images: [
      'kiosque13.png',
      'kiosque6.png',
      'kiosque3.png',
      'produits1.png',
      'kiosque1.png',
      'kiosque7.png',
      'produits3.png',
      'kiosque14.png',
      'produits2.png',
      'kiosque4.png',
      'kiosque2.png',
      'kiosque10.png',
      'kiosque12.jpg',
      'kiosque15.png',
      'kiosque5.png',
      'kiosque11.jpg',
      'kiosque8.png',
      'kiosque17.jpg',
      'kiosque16.jpg',
      'kiosque9.png',
      'kiosque18.jpg'
    ]
  },
  {
    name: 'Affichage',
    description:
      'Nous réalisons et installons des affiches de toutes tailles, adaptées à tous types d’événements : salons, festivals, promotions commerciales, et bien plus encore. De la conception en atelier à la pose sur site, nous vous offrons un service clé en main pour garantir un impact visuel optimal.',
    thumbnail: 'affichage.png',
    url: 'affichage',
    images: [
      'affichage-bmr_2025.jpg',
      'affichage-photomaton_2025.jpg',
      'affichage1.jpeg',
      'affichage10.jpeg',
      'affichage-bmr-4_2025.jpg',
      'affichage4.jpeg',
      'affichage5.jpeg',
      'affichage11.jpeg',
      'affichage8.jpeg',
      'affichage-bmr-2_2025.jpg',
      'affichage3.jpeg',
      'affichage9.jpeg',
      'affichage13.jpeg',
      'affichage12.png',
      'affichage2.jpeg',
      'affichage14.jpeg',
      'affichage-bmr-3_2025.jpg',
      'affichage15.jpeg',
      'affichage16.jpeg',
      'affichage6.jpeg',
      'affichage20.png',
      'affichage18.jpeg',
      'affichage17.jpeg',
      'affichage23.png',
      'affichage22.png',
      'affichage21.jpeg',
      'affichage24.jpeg',
      'affichage25.jpeg',
      'affichage26.png'
    ]
  },
  {
    name: 'Photomatons',
    description:
      'Les photomatons sont devenus très populaires ces dernières années, que ce soit pour les créateurs de contenu ou pour les familles! Nous avons réalisé plusieurs espaces qui ont été installés dans les centres commerciaux (Laurier Québec, les Galeries d’Anjou), mais aussi à l’extérieur (Festival d’été de Québec).',
    thumbnail: 'photomaton.jpg',
    url: 'photomatons',
    images: [
      'photomaton-laurier_2025.jpg',
      'photomaton-dermapure_2025.jpg',
      'photomaton-quebec.jpg',
      'PhotoBooth2.png',
      'PhotoBooth7.jpeg',
      'photomaton-1_2025.jpg',
      'PhotoBooth1.png',
      'PhotoBooth6.jpeg',
      'PhotoBooth3.png',
      'PhotoBooth5.png',
      'PhotoBooth8.png',
      'PhotoBooth4.jpeg',
      'feq.png',
      'laurier.png'
    ]
  },
  {
    name: 'Scupltures',
    description:
      'Quel que soit le style, la sculpture repousse les limites de la création, transformant l’espace et éveille l’imagination! Nous réalisons des projets de toutes les tailles avec plusieurs types de matériaux.',
    thumbnail: 'sculpture.png',
    url: 'sculptures',
    images: [
      'bottes.jpg',
      'sculpture1.png',
      'mini-putt-1.png',
      'sculpture2.png',
      'sculpture3.png',
      'sculpture4.png',
      'sculpture5.png',
      'sculpture-produits.png',
      'sculpture7.png',
      'sculpture10.jpg',
      'ccbn-chapeau.jpeg',
      'arbre2.png',
      'sculpture8.png',
      'ananas.png',
      'guitare-2.jpg',
      'sculpture12.jpg',
      'sculpture13.jpg',
      'sculpture9.jpg',
      'sculpture14.png',
      'sculpture15.jpg',
      'sculpture16.jpg',
      'sculpture6.jpg',
      'sculpture17.png',
      'sculpture18.png',
      'abeille.png',
      'sculpture19.jpg',
      'arbre3.jpeg',
      'pops.jpeg',
      'ccbn-2.png',
      'guitare.png'
    ]
  },
  {
    name: 'Expositions',
    description:
      'Réaliser un décor pour une exposition, c’est concevoir un espace immersif qui met en valeur les œuvres ou les produits tout en guidant le regard et l’expérience du visiteur. Chaque élément du décor joue un rôle essentiel : il raconte une histoire, crée une ambiance et renforce l’impact du message à transmettre.',
    thumbnail: 'exposition.png',
    url: 'expositions',
    images: [
      'expo2.jpeg',
      'cercle-polaire2.jpeg',
      'ccbn1.png',
      'expo8.png',
      'expo13.jpg',
      'expo3.jpeg',
      'expo-mode.png',
      'cercle-polaire1.png',
      'expo9.png',
      'ccbn2.jpeg',
      'expo5.jpg',
      'expo4.jpeg',
      'expo11.jpg',
      'LGBTQ.png',
      'expo17.png',
      'expo12.png',
      'broue.png',
      'machine.jpeg',
      'expo18.png',
      'expo14.jpeg',
      'expo6.jpg',
      'expo10.jpg',
      'miracles.jpeg',
      'ccbn2.png',
      'expo15.jpeg',
      'expo16.png'
    ]
  },
  {
    name: 'Événements privés',
    description:
      'Le décor d’une soirée privée est bien plus qu’un simple habillage : il crée une atmosphère, transporte les invités dans un univers et donne le ton de l’événement. Nous réalisons des decors pour des soirées corporatifs, des mariages, des événements spéciaux, etc.',
    thumbnail: 'soiree.png',
    url: 'soirees-privees',
    images: [
      'soiree16.jpg',
      'soiree1.jpeg',
      'soiree2.jpeg',
      'soiree3.png',
      'bmr_2025.jpg',
      'soiree8.jpeg',
      'soiree6.png',
      'soiree5.jpeg',
      'soiree4.jpeg',
      'soiree9.jpg',
      'soiree10.jpg',
      'soiree11.jpeg',
      'soiree7.jpg',
      'feq-01.jpg',
      'soiree12.png',
      'bmr-2_2025.jpg',
      'feq-2_2025.jpg',
      'soiree13.jpg',
      'soiree14.png',
      'soiree15.png',
      'feq_2025.jpg'
    ]
  },
  {
    name: 'Commercial',
    description:
      'Nos décors transforment les espaces publics en environnements immersifs, attrayants et parfaitement intégrés à l’expérience client. Nous réalisons et installons des décors sur mesure pensés pour résister à un fort achalandage, tout en offrant une finition impeccable.',
    thumbnail: 'commercial.jpg',
    url: 'commercial',
    images: [
      'commercial4.jpeg',
      'commercial6.jpg',
      'commercial5.jpeg',
      'commercial2.jpg',
      'commercial3.jpeg',
      'commercial8.jpeg',
      'commercial1.jpg',
      'commercial7.jpg'
    ]
  },
  {
    name: 'Lettres géantes',
    description:
      'Réalisation de lettres/logo en grand format! Qu’il s’agisse d’un salon professionnel, d’un lancement de produit ou d’un aménagement urbain, chaque logo géant doit être pensé pour impressionner tout en restant fidèle à l’image de marque.',
    thumbnail: 'lettres_2025.jpg',
    url: 'lettres-geantes',
    images: [
      'kwe.png',
      'blizz.png',
      'mbdq.jpeg',
      'bmr2.jpeg',
      'feq1.png',
      'e.png',
      'feq2.jpg',
      'pls.jpeg',
      'bmr1.jpeg',
      'joe.jpeg'
    ]
  },
  {
    name: 'Végétation',
    description:
      'Les aménagements végétaux artificiels sont une alternative efficace pour intégrer de la verdure dans tous types d’espaces, sans les contraintes liées à l’entretien des plantes naturelles. Nous réalisons des murs végétaux, des jardins, des plantes, des arbres, etc.',
    thumbnail: 'vegetation.png',
    url: 'vegetation',
    images: [
      'quebec_2025.jpg',
      'vegetation14.png',
      'vegetation1.png',
      'arbre1.png',
      'vegetation13.png',
      'vegetation9.jpg',
      'vegetation3.png',
      'vegetation4.png',
      'vegetation11.png',
      'vegetation5.png',
      'vegetation10.png',
      'vegetation6.png',
      'vegetation7.png',
      'vegetation8.png',
      'vegetation2.png',
      'arbre3.png',
      'vegetation12.png',
      'vegetation15.jpg'
    ]
  },
  {
    name: 'Faux finis',
    description:
      "La création de faux finis en peinture est une technique permettant d'imiter à la perfection divers matériaux comme le bois, la pierre, la brique, la glace ou le métal. Nos techniques avancées de peinture et de patine nous permettent de reproduire fidèlement l'apparence et la texture des matériaux naturels, avec un souci du détail qui garantit un résultat bluffant.",
    thumbnail: 'pierres.png',
    url: 'faux-finis',
    images: [
      'rose_2025.jpg',
      'mini-putt-1_2025.jpg',
      'faux-fini2.png',
      'pierre2.png',
      'pierre6.png',
      'faux-fini1.png',
      'pierre5.png',
      'pierre4.png',
      'volcan.png',
      'pierre3.png',
      'bfly-grotte.jpg',
      'pierre9.png',
      'bfly-glace.jpg',
      'pierre8.png',
      'pierre1.png'
    ]
  },
  {
    name: 'Corporatif',
    description:
      'Conçus en atelier et installés avec précision, nos décors sur mesure donnent vie à vos événements corporatifs avec un rendu professionnel et soigné.',
    thumbnail: 'corporatif.jpg',
    url: 'corporatif',
    images: [
      'bmr-5_2025.jpg',
      'corpo-1.jpg',
      'bmr-4_2025.jpg',
      'corpo-2.jpg',
      'bmr-1_2025.jpg',
      'bmr-2_2025.jpg',
      'bmr-1_2024.jpg',
      'corpo-9.jpg',
      'bmr-2_2024.jpg',
      'corpo-5.png',
      'bmr-3_2024.jpg',
      'bmr-3_2025.jpg',
      'corpo-3.png',
      'bmr-6_2025.jpg',
      'corpo-8.jpg',
      'corpo-4.jpg',
      'bmr-7_2025.jpg',
      'corpo-7.jpg',
      'corpo-6.jpg'
    ]
  },
  {
    name: 'Terrasses',
    description:
      'Nous réalisons des terrasses et du mobilier extérieur sur mesure, alliant esthétique, durabilité et confort. Profitez pleinement de vos espaces extérieurs avec des créations uniques et adaptées à vos besoins.',
    thumbnail: 'terrasses.png',
    url: 'terrasses',
    images: [
      'terrasse3.jpeg',
      'terrasse10.jpeg',
      'terrasse1.jpeg',
      'terrasse5.jpg',
      'terrasse13.png',
      'terrasse7.jpg',
      'terrasse6.jpeg',
      'terrasse8.jpeg',
      'terrasse9.png',
      'terrasse11.jpeg',
      'terrasse12.jpeg',
      'terrasse14.png',
      'terrasse15.jpg',
      'terrasse4.jpeg',
      'terrasse.jpeg'
    ]
  },
  {
    name: 'Fêtes',
    description:
      'Créer un décor festif, c’est offrir un univers enchanteur qui émerveille petits et grands. Grâce à des éléments bien choisis et une mise en scène équilibrée, l’esprit des fêtes prend vie dans chaque espace, rendant cette période encore plus magique et mémorable.',
    thumbnail: 'fetes_2025.jpg',
    url: 'fetes',
    images: [
      'fetes-1_2025.jpg',
      'fetes1.png',
      'fetes-2_2025.jpg',
      'fetes7.jpeg',
      'fetes3.png',
      'fetes9.png',
      'fetes8.jpeg',
      'fetes12.jpeg',
      'manoir_2024.jpg',
      'fetes13.png',
      'fetes4.jpeg',
      'fetes14.jpeg',
      'fetes16.png',
      'fetes10.jpeg',
      'fetes15.png',
      'fetes2.png',
      'fetes11.jpeg'
    ]
  },
  {
    name: 'Métaux',
    description:
      'Notre service de travail du métal allie précision technique et créativité artistique pour donner vie à des projets aussi solides qu’esthétiques. Qu’il s’agisse de réalisations structurelles, ornementales ou mécaniques, nous maîtrisons l’art de la découpe, du roulage et de l’assemblage — par soudure ou fixations mécaniques — afin de concrétiser des idées uniques avec rigueur et élégance.',
    thumbnail: 'metaux.png',
    url: 'metaux',
    images: [
      'metal1.jpg',
      'metal2.jpg',
      'metal3.jpg',
      'metal4.jpg',
      'metal5.jpg',
      'metal6.jpg',
      'metal7.jpg',
      'metal8.jpg',
      'metal9.jpg',
      'metal10.jpg',
      'metal11.jpg',
      'metal12.jpg',
      'metal13.jpg',
      'metal14.jpg',
      'metal15.jpg',
      'metal16.jpg',
      'metal17.jpg',
      'metal18.jpg'
    ]
  },
  {
    name: 'Jeux',
    description:
      'Qu’il s’agisse de plateaux pour des jeux télévisés, de zones ludiques pour enfants ou de structures interactives pour événements, nous donnons vie à des décors qui font jouer l’imaginaire. Chaque projet est pensé pour stimuler la participation, assurer la sécurité et capter l’attention grâce à une finition professionnelle et des matériaux adaptés à un usage fréquent.',
    thumbnail: 'jeux.png',
    url: 'jeux',
    images: [
      'jeux20.jpg',
      'jeux16.png',
      'jeux1.png',
      'jeux2.png',
      'jeux3.jpg',
      'jeux4.png',
      'jeux5.jpg',
      'jeux12.jpg',
      'jeux8.jpg',
      'jeux6.jpg',
      'jeux13.jpg',
      'jeux9.png',
      'jeux16.jpeg',
      'jeux14.jpg',
      'jeux7.jpg',
      'jeux10.jpg',
      'jeux15.png',
      'jeux18.jpeg',
      'jeux17.jpeg',
      'jeux11.jpg',
      'jeux19.jpeg'
    ]
  },
  {
    name: 'Murales',
    description:
      'Les murales transforment les espaces publics en véritables expériences visuelles. Elles peuvent également jouer un rôle crucial dans le développement des enfants en réadaptation!',
    thumbnail: 'murale.png',
    url: 'murales',
    images: [
      'murale-9.jpg',
      'murale-3.jpg',
      'murale-10.jpg',
      'murale-2.jpg',
      'murale-4.jpg',
      'murale-1.jpg',
      'murale-15.png',
      'murale-5.jpg',
      'murale-6.jpg',
      'murale-7.jpg',
      'murale-13.png',
      'murale-8.jpg',
      'murale-12.png',
      'murale-11.jpg',
      'murale-14.png',
      'murale-16.png',
      'murale-17.png',
      'murale-18.jpg',
      'murale-19.png'
    ]
  },
  {
    name: 'Modelage',
    description:
      'Le modelage est une technique de sculpture qui se pratique sur des matières malléables (comme le PVC). Au fils des années, nous avons développé une expertise dans la création de fleurs. Nous pouvons les créer de toutes les tailles, formes et couleurs! De plus, elles peuvent être exposés à l’intérieur comme à l’extérieur.',
    thumbnail: 'modelage.png',
    url: 'modelage',
    images: [
      'fleur1.png',
      'modelage-bfly2.png',
      'fleur3.png',
      'fleur5.png',
      'fleur4.png',
      'modelage-bfly1.png',
      'fleur6.jpeg',
      'fleur7.jpeg'
    ]
  }
]
